import { ROUTES_ADD_MEMBER, ROUTES_UNAUTHORIZED } from '@/constants/routes';
import store from '@/store';
import { i18n } from '@/lang';

export default {
    path: '/add-member',
    name: ROUTES_ADD_MEMBER,
    beforeEnter: guardRouteAddMember,
    component: () => import(/*webpackChunkName: 'add-member'*/ '@/views/AddMember.vue')
};

function guardRouteAddMember(to, from, next) {
    if (store.getters.isSelectedClubIndividual || !store.getters['userPermissions/canInviteMembers']) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_UNAUTHORIZED });
    } else {
        next();
    }
}
